<template>
    <div>
        <div v-if="empty && !loading">
            Es befinden sich keine Artikel in Ihrem Einkaufswagen
        </div>
        <div v-if="!empty && !loading">
            <cart-small-row v-for="item in items" :key="item.rowId" :item="item"></cart-small-row>
            <div class="sum">
                <b>Zwischensumme:</b> € {{ total }}
            </div>
            <div class="row">
                <a class="btn btn-default" :href="url">Zum Warenkorb</a><a class="btn btn-primary" href="/checkout">Zur Kasse</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            items: {},
            empty: 1,
            loading: 1,
            data: {
                total: '0'
            }
        }
    },
    created() {
        App.event.listen('cart.data.loaded', (response) => {
            this.items = response.items;
            this.data  = response.data;

            if(this.items.length > 0) {
                this.empty = 0;
            } else {
                this.empty = 1;
            }
            this.loading = 0;
        });

        App.event.listen('cart.updated', (response) => {
            this.items = response.items;
            this.data = response.data;

            if(this.items.length > 0) {
                this.empty = 0;
            } else {
                this.empty = 1;
            }
        });
    },

    computed: {
        url() {
            return App.url + '/cart';
        },

        total() {
            let val = parseFloat(this.data.fullPrice).toFixed(2);
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }

}
</script>
